import { MediaMeta, MediaType } from "@/pages/mediaManager"
import { Button, Card, Center, Input, Text } from "@chakra-ui/react"
import { faCancel, faUpload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Viewer } from "@react-pdf-viewer/core"
import { useEffect, useState } from "react"
import { v4 } from "uuid"

const PdfChecker: React.FC<{
	currentDocument: File,
	onAdd: (newMedia: MediaMeta, file: File, icon?: File) => void
	onValidate: (newMedia: MediaMeta) => string | undefined
}> = ({ currentDocument, onAdd, onValidate }) => {
	const [invalid, setInvalid] = useState<string | undefined>(undefined)
	function makeMedia(): MediaMeta {
		const id = v4()
		return {
			id: `${id}.pdf`,
			iconId: `${id}.png`,
			name: currentDocument.name.slice(0, currentDocument.name.lastIndexOf('.')),
			type: MediaType.Pdf,
			uploaded: new Date(),
			fileUrl: URL.createObjectURL(currentDocument),
			references: [],
			size: currentDocument.size,
		}
	}
	const [newMedia, setNewMedia] = useState<MediaMeta>(makeMedia())

	useEffect(() => {
		setNewMedia(makeMedia())
	}, [currentDocument])

	useEffect(() => {
		setInvalid(onValidate(newMedia))
	}, [newMedia])

	return (
		<Center flexDir='column' gap={3} paddingY={3}>
			<Card variant='outline' w='100%' maxH='60vh' overflowY='scroll'>
				<Viewer fileUrl={newMedia.fileUrl!} />
			</Card>
			<Center gap={3} paddingY={3} w='100%'>
				<Text as='b' w={195}> Item Name: </Text>
				<Input
					flex={1}
					placeholder="Item Name"
					value={newMedia.name}
					onChange={(e) => setNewMedia({ ...newMedia, name: e.target.value })}
				/>
			</Center>
			<Center paddingY={3} gap={3} w='100%'>
				{invalid ? (
					<Button leftIcon={<FontAwesomeIcon icon={faCancel} />} flex={1} isDisabled>{invalid}</Button>
				) : (
					<Button leftIcon={<FontAwesomeIcon icon={faUpload} />} flex={1} onClick={() => onAdd(newMedia, currentDocument)}>Upload PDF</Button>
				)}
			</Center>
		</Center>
	)
}

export default PdfChecker
